<template>
<v-card>
  <v-toolbar
    color="lava"
    dark
  >
    <v-toolbar-title>通知の全体表示</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn icon tile @click="$emit('closeModal')">
      <v-icon color="white" size="50">mdi-close</v-icon>
    </v-btn>    
  </v-toolbar>
  <div class="d-flex" style="height:80vh">
    <v-list two-line style="overflow: scroll; height:80vh; width:50%;" class="px-1">
      <v-list-item-group
        v-model="selected"
        active-class="pink--text"
      >
        <v-list-item v-for="(item,i) in notify" :key="i">
          <template v-slot:default="{ active }">
            <v-list-item-content>
              <v-list-item-title v-if="item&&item.title">{{ item.title }}</v-list-item-title>
              <!-- <div v-html="item.content"></div> -->
            </v-list-item-content>

            <v-list-item-action>
              <v-chip :color="item.isImportant?'#BA0009':'#399942'" dark class="ml-auto"><span v-if="item&&item.tag" v-text="item.tag"></span></v-chip>
              <p class="mb-0" v-if="item&&item.createdAt">{{ item.createdAt.toDate().getMonth() + 1 }}/{{ item.createdAt.toDate().getDate() }} <span class="mr-2"></span> {{ item.createdAt.toDate().getHours()}}:<span v-if="item.createdAt.toDate().getMinutes()>9" v-text="item.createdAt.toDate().getMinutes()"></span><span v-else>0{{ item.createdAt.toDate().getMinutes() }}</span></p>
              <v-icon v-if="!active&&false" color="grey lighten-1">mdi-star-outline</v-icon>
              <v-icon v-else-if="false" color="yellow darken-3">mdi-star</v-icon>
            </v-list-item-action>
          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <div style="width:50%; overflow: scroll; height:80vh;" class="px-4 pt-2">
      <p v-if="!notify[selected]" class="cloud--text text-center">選択した通知の内容を表示します。</p>
      <v-card v-else flat tile>
        <v-card-title><v-chip class="mr-1" :color="notify[selected].isImportant?'#BA0009':'#399942'" dark><span v-text="notify[selected]&&notify[selected].tag"></span></v-chip><span v-if="notify[selected]&&notify[selected].title" v-text="notify[selected].title"></span></v-card-title>
        <v-card-subtitle v-if="notify[selected]&&notify[selected].createdAt">{{ notify[selected].createdAt.toDate().toLocaleString() }}</v-card-subtitle>
        <div v-if="notify[selected]&&notify[selected].content" v-html="autoLink(notify[selected].content)"></div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="enabledCheckNotify(notify[selected].type)" color="primary" @click="checkNotify(notify[selected])">見にいく</v-btn>
        </v-card-actions>
      </v-card>        
    </div>
  </div>
</v-card>
</template>

<script>
import firebase from 'firebase'
export default ({
  props: {
    isSp: Boolean,
    sort: Number,
    onlyImportant: Boolean,
  },
  data () {
    return {
    db:null,
    notiDesk: false,
    notiMob: false,
    notiLine: false,
    toUser: "all",
    content:"",
    toTheUser: "",
    selected: -1,
  }},
  computed:{
    admins(){
      return this.$store.state.admins
    },
    liqAdmins(){
      return this.$store.state.liqAdmins
    },
    namelist(){
      return this.$store.state.namelist
    },
    isAdmin(){
      return this.$store.state.isAdmin
    },
    basetitle(){
      return this.$store.state.basetitle
    },
    lid(){
      return this.$store.state.lid
    },
    alid(){
      return this.$store.state.alid
    },
    config(){
      return this.$store.state.config
    },
    members(){
      return this.$store.state.members
    },
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    currentName() {
      return this.$store.state.auth.user.displayName;
    },
    isAuthed() {
      return !this.$store.state.auth.user.isAnonymous || false;
    },
    notify(){
      return this.onlyImportant ? this.$store.state.notifys.filter(item=>item.isImportant&&!item.read) : this.$store.state.notifys
    },
  },
  created(){
    this.db = firebase.firestore()
    //console.log("created",this.pageTitle,this.currentName,this.uid)
    this.selected = this.sort
  },
  mounted(){

  },
  watch:{
    sort:{
      handler: function(val, oldVal){
        console.log(val)
        this.selected = val
      }
    }
  }, 
  methods: {
    autoLink(text) {
      return text
        .replace(/(https?:\/\/[^\s]*)/g, (match, p1) => {
          return p1.indexOf('href') > -1 ? p1 : `<a href='${p1}' target="_blank">${p1}</a>`
        })
        .replaceAll("<a", "<a style='word-break: break-all;'")
        .replaceAll("\n", "<br>")
    },
    //通知
    checkNotify(item,index){
      const type = item.type;
      if(type==0&&item.lidid!=="workspace") this.$router.push("/home?page=news")
      if(type==0&&item.lidid=="workspace") this.$router.push("/workspace/"+item.pjid+"?page=news")
      if(type==1&&item.lidid!=="workspace") this.$router.push("/home")
      if(type==1&&item.lidid=="workspace") this.$router.push("/workspace/"+item.pjid)
      if(type==2&&item.lidid!=="workspace") this.$router.push("/home?page=offline")
      if(type==2&&item.lidid=="workspace") this.$router.push("/workspace/"+item.pjid+"?page=offline")
      if(type==3||type==5||type==7||type=="l1") this.$router.push(`/lid/${item.lidid}/content`)
      if(type==8 || type==9) this.$router.push(`/lid/${item.lidid}/idea`)
      if(type==31||type==32||type==33||type==34) this.$router.push(`/lid/${item.lidid}/idea?id=${item.ideaid}`)
      if(type==10 || type==11 || type==12 || type==13 || type==14 || type==15 || type==16 || type==17 || type==18 || type==19 || type==20 || type==21 || type==22 || type==29) this.$router.push(`/lid/${item.lidid}/project?id=${item.pjid}`)
      this.$emit('closeModal')
    },
    enabledCheckNotify(type) {
      // checkNotifyの条件を満たしているかどうか
      return type==0 || type==1 || type==2 || type==3 || type==5 || type==7 || type=="l1" || type==8 || type==9 || type==10 || type==11 || type==12 || type==13 || type==14 || type==15 || type==16 || type==17 || type==18 || type==19 || type==20 || type==21 || type==22 || type==29 || type==31 ||type==32 ||type==33 || type==34
    }
  },

}) 
</script>

<style scoped>
*{
  font-family:mplus-2c-medium;
}

</style>
